module.exports = __webpack_public_path__ + "img/porschetaycanbg.48bcc788.png";